import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as actions from "../../../store/actions";
import * as configActions from "../../../store/config/actions";
import { CompetitionsService } from "../../../services/competitions";
import { SUPER_ADMIN, ADMIN, TEACHER } from "../../../constants";
import "./style.scss";
import { textIdentifier } from "../../../textIdentifier";

export default function CompetitionDashboardComponent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isFetching, setIsFetching] = useState(true);
  const [competitions, setCompetitions] = useState([]);
  const [filteredCompetitions, setFilteredCompetitions] = useState([]);
  const { userType, userData } = useSelector((state) => state.auth);
  const { selectedClass,lang } = useSelector((state) => state.main);

  useEffect(() => {
    if (userData.school) {
      dispatch(
        actions.selectSchool({
          id: userData.school,
          name: userData.organization,
        })
      );
    }
    if (userData?.classes?.length > 0) {
      let selectedClass = sessionStorage.getItem("class_code");
      if(!!selectedClass){
        dispatch(actions.selectClass({ code: sessionStorage.getItem("class_code") }));
      }
      else{
        dispatch(actions.selectClass({ code: userData.classes[0] }));
      }
    }
  }, [userData]);

  const selectCompetition = (comp, e, isViewingStatus,type) => {
    e.preventDefault();
    dispatch(actions.selectCompetition(comp));
    if (isViewingStatus) {
      dispatch(actions.setIsViewingStatus(true));
    }
    switch (userType) {
      case SUPER_ADMIN:
        navigate(`/schools`);
        break;
      case ADMIN:
        navigate(`/schools/${userData.school}/classes`);
        break;
      case TEACHER:
        if(type=="student_list"){
          navigate(
            `/schools/${userData.school}/classes/${selectedClass?.code}/students`
          );
        }
        else if(type=="status"){
          navigate(
            `/schools/${userData.school}/classes/${selectedClass?.code}/status`
          );
        }
        break;
      default:
        break;
    }
  };

  const viewSyllabus = (comp, e) => {
    e.preventDefault();
    dispatch(actions.selectCompetition(comp));
    navigate(`/syllabus`);
  };

  const handleSelectClass = (classCode) => {
    if(!!sessionStorage.getItem("class_code")){
      sessionStorage.removeItem("class_code")
    }
    setFilteredCompetitions(
      competitions.filter((item) => item.classes.includes(classCode))
    );
    dispatch(actions.selectClass({ code: classCode }));
  };

  const handleFetchCompetitions = async () => {
    try {
      let selectedClass = sessionStorage.getItem("class_code");
      const res = await CompetitionsService();
      setCompetitions(res.data);
      if (userType === TEACHER && res.data[0]?.classes?.length > 0) {
        if(!!selectedClass){
          const classCode = selectedClass;
          setFilteredCompetitions(
            res.data.filter((item) => item.classes.includes(classCode))
          );
          dispatch(actions.selectClass({ code: classCode }));
        }
        else{
        const classCode = res.data[0].classes[0];
        setFilteredCompetitions(
          res.data.filter((item) => item.classes.includes(classCode))
        );
        dispatch(actions.selectClass({ code: classCode }));
        }
      } else {
        setFilteredCompetitions(res.data);
      }
    } catch (error) {
      dispatch(configActions.showAlert(error?.data?.message));
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    dispatch(actions.setIsViewingStatus(false));
  }, []);

  useEffect(() => {
    handleFetchCompetitions();
  }, []);

  const getButtonName = () => {
    switch (userType) {
      case SUPER_ADMIN:
        return textIdentifier['schools-classes'][lang];
      case ADMIN:
        return textIdentifier['view-classes'][lang];
      case TEACHER:
        return textIdentifier['students-list'][lang];
      default:
        break;
    }
  };

  const renderStatusChipJSX = (start_time, end_time) => {
    let s = new Date(start_time).getTime();
    let n = new Date().getTime();
    let e = new Date(end_time).getTime();

    if (s > n) {
      // yet to start
      return (
        <div className="chip chip-warning">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
              stroke="#2E2E2E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 6.66667C6 6.48986 6.07024 6.32029 6.19526 6.19526C6.32029 6.07024 6.48986 6 6.66667 6H9.33333C9.51014 6 9.67971 6.07024 9.80474 6.19526C9.92976 6.32029 10 6.48986 10 6.66667V9.33333C10 9.51014 9.92976 9.67971 9.80474 9.80474C9.67971 9.92976 9.51014 10 9.33333 10H6.66667C6.48986 10 6.32029 9.92976 6.19526 9.80474C6.07024 9.67971 6 9.51014 6 9.33333V6.66667Z"
              stroke="#2E2E2E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>{textIdentifier['yet-to-start'][lang]}</span>
        </div>
      );
    }

    if (n < e) {
      return (
        <div className="chip chip-success">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="10"
            viewBox="0 0 18 14"
            fill="none"
          >
            <path
              d="M3.69673 12.3034C3.00028 11.607 2.44783 10.7802 2.07091 9.87026C1.694 8.96031 1.5 7.98503 1.5 7.00011C1.5 6.01519 1.694 5.03991 2.07091 4.12996C2.44783 3.22002 3.00028 2.39322 3.69673 1.69678M14.3034 1.69678C14.9998 2.39322 15.5523 3.22002 15.9292 4.12996C16.3061 5.03991 16.5001 6.01519 16.5001 7.00011C16.5001 7.98503 16.3061 8.96031 15.9292 9.87026C15.5523 10.7802 14.9998 11.607 14.3034 12.3034M6.0534 9.94595C5.27227 9.16458 4.83345 8.10496 4.83345 7.00011C4.83345 5.89526 5.27227 4.83564 6.0534 4.05428M11.9467 4.05428C12.7279 4.83564 13.1667 5.89526 13.1667 7.00011C13.1667 8.10496 12.7279 9.16458 11.9467 9.94595M9.8334 7.00011C9.8334 7.22112 9.7456 7.43309 9.58932 7.58937C9.43304 7.74565 9.22108 7.83344 9.00006 7.83344C8.77905 7.83344 8.56709 7.74565 8.41081 7.58937C8.25453 7.43309 8.16673 7.22112 8.16673 7.00011C8.16673 6.7791 8.25453 6.56714 8.41081 6.41086C8.56709 6.25458 8.77905 6.16678 9.00006 6.16678C9.22108 6.16678 9.43304 6.25458 9.58932 6.41086C9.7456 6.56714 9.8334 6.7791 9.8334 7.00011Z"
              stroke="#2E2E2E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>{textIdentifier['ongoing'][lang]}</span>
        </div>
      );
    }

    if (n > e) {
      return (
        <div className="chip chip-danger">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="10"
            viewBox="0 0 18 18"
            fill="none"
          >
            <path
              d="M14.3034 14.3034L3.69671 3.69671M14.3034 14.3034C15.7099 12.8968 16.5001 10.9892 16.5001 9.00005C16.5001 7.01091 15.7099 5.10324 14.3034 3.69671C12.8968 2.29018 10.9892 1.5 9.00005 1.5C7.01091 1.5 5.10324 2.29018 3.69671 3.69671L14.3034 14.3034ZM14.3034 14.3034C12.8968 15.7099 10.9892 16.5001 9.00005 16.5001C7.01091 16.5001 5.10324 15.7099 3.69671 14.3034C2.29018 12.8968 1.5 10.9892 1.5 9.00005C1.5 7.01091 2.29018 5.10324 3.69671 3.69671L14.3034 14.3034Z"
              stroke="#2E2E2E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <span>{textIdentifier['ended'][lang]}</span>
        </div>
      );
    }
  };

  const renderTimeStringJSX = (start_time, end_time) => {
    const startTime = new Date(start_time);
    const endTime = new Date(end_time);

    function getDateString(date) {
      const d = new Date(date);
      const newDate= d.toLocaleDateString([], {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      return newDate.split("T")[0].split("-").reverse().join("-");
    }

    return (
      <Fragment>
        <span>{getDateString(startTime)} </span>
        <span className="text-primary">
          {startTime
            .toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })
            .toLowerCase()}{" "}
        </span>
        <span>to </span>
        <span>{getDateString(endTime)} </span>
        <span className="text-primary">
          {endTime
            .toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })
            .toLowerCase()}{" "}
        </span>
      </Fragment>
    );
  };

  if (isFetching) {
    return null;
  }

  return (
    <div className="competition-dashboard">
      {userType === TEACHER && (
        <div className="classSelectionDropdown dropdown">
          <button
            className="btn dropdown-toggle"
            type="button"
            id="classSelectionDropdown"
            data-bs-toggle="dropdown"
            data-bs-offset="0,12"
            aria-expanded="false"
          >
            <div>
              <p>{textIdentifier['class-selected'][lang]}</p>
              <p>{selectedClass?.code}</p>
            </div>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="14"
              viewBox="0 0 22 14"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.11529 1.3153C1.5091 0.921611 2.04315 0.700448 2.59999 0.700448C3.15684 0.700448 3.69089 0.921611 4.08469 1.3153L11 8.2306L17.9153 1.3153C18.109 1.11473 18.3407 0.954746 18.5969 0.844687C18.8532 0.734628 19.1287 0.676697 19.4076 0.674274C19.6864 0.671851 19.9629 0.724984 20.221 0.830574C20.4791 0.936163 20.7136 1.0921 20.9107 1.28927C21.1079 1.48644 21.2638 1.72091 21.3694 1.979C21.475 2.23708 21.5281 2.51361 21.5257 2.79244C21.5233 3.07128 21.4654 3.34684 21.3553 3.60305C21.2453 3.85926 21.0853 4.09098 20.8847 4.2847L12.4847 12.6847C12.0909 13.0784 11.5568 13.2996 11 13.2996C10.4432 13.2996 9.9091 13.0784 9.5153 12.6847L1.11529 4.2847C0.721605 3.89089 0.500443 3.35684 0.500443 2.8C0.500443 2.24315 0.721605 1.70911 1.11529 1.3153Z"
                fill="#0059B1"
              />
            </svg>
          </button>

          <ul
            className="dropdown-menu shadow"
            aria-labelledby="dropdownMenuButton1"
          >
            {userData?.classes?.map((_class) => (
              <li key={_class} onClick={() => handleSelectClass(_class)}>
                {_class}
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="card-groups">
        {Array.isArray(competitions) &&
          filteredCompetitions.map((_, i) => {
            const durationInMinutes = Math.floor(_.duration / 60);
            const minutes =
              durationInMinutes > 59
                ? durationInMinutes % 60
                : durationInMinutes;
            const hours = Math.floor(durationInMinutes / 60);
            return (
              <div className="card" key={i}>
                <div className="card-body">
                  <h5 className="card-title">
                    {i + 1}. {_.name}
                  </h5>

                  <div className="row">
                    <div className="col-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="25"
                        viewBox="0 0 26 25"
                        fill="none"
                      >
                        <path
                          d="M6.33333 11.9999L10.3333 7.99992L14.3333 11.9999L19.6667 6.66658M7.66667 23.9999L13 18.6666L18.3333 23.9999M1 1.33325H25M2.33333 1.33325H23.6667V17.3333C23.6667 17.6869 23.5262 18.026 23.2761 18.2761C23.0261 18.5261 22.687 18.6666 22.3333 18.6666H3.66667C3.31304 18.6666 2.97391 18.5261 2.72386 18.2761C2.47381 18.026 2.33333 17.6869 2.33333 17.3333V1.33325Z"
                          stroke="#2E2E2E"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="mx-1">{textIdentifier['status'][lang]} :</span>
                    </div>

                    <div className="col-8">
                      <div className="chip-container">
                        {renderStatusChipJSX(_.start_time, _.end_time)}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                      >
                        <path
                          d="M13 7.66667V13L17 17M25 13C25 14.5759 24.6896 16.1363 24.0866 17.5922C23.4835 19.0481 22.5996 20.371 21.4853 21.4853C20.371 22.5996 19.0481 23.4835 17.5922 24.0866C16.1363 24.6896 14.5759 25 13 25C11.4241 25 9.86371 24.6896 8.4078 24.0866C6.95189 23.4835 5.62902 22.5996 4.51472 21.4853C3.40042 20.371 2.5165 19.0481 1.91345 17.5922C1.31039 16.1363 1 14.5759 1 13C1 9.8174 2.26428 6.76516 4.51472 4.51472C6.76516 2.26428 9.8174 1 13 1C16.1826 1 19.2348 2.26428 21.4853 4.51472C23.7357 6.76516 25 9.8174 25 13Z"
                          stroke="#2E2E2E"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="mx-1">{textIdentifier['duration'][lang]} :</span>
                    </div>

                    <div className="col-8">
                      <span>{hours ? hours +' '+textIdentifier["hour(s)"][lang] : ""}</span>
                      <span>{minutes ? minutes +' '+textIdentifier["minute(s)"][lang] : ""}</span>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M16.334 2.75H7.665C4.644 2.75 2.75 4.889 2.75 7.916V16.084C2.75 19.111 4.634 21.25 7.665 21.25H16.333C19.364 21.25 21.25 19.111 21.25 16.084V7.916C21.25 4.889 19.364 2.75 16.334 2.75Z"
                          stroke="#2E2E2E"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 8.25V12.25L15 15.25"
                          stroke="#2E2E2E"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="mx-1">{textIdentifier['from'][lang]} :</span>
                    </div>

                    <div className="col-8">
                      {renderTimeStringJSX(_.start_time, _.end_time)}
                    </div>
                  </div>
                </div>

                <div className="card-footer">
                  <Link to="" onClick={(e) => viewSyllabus(_, e)}>
                    <button className="btn-contained">{textIdentifier["view-syllabus"][lang]}</button>
                  </Link>
                  <Link to="" onClick={(e) => selectCompetition(_, e, false,"student_list")}>
                    <button className="btn-contained">
                      {getButtonName(userType)}
                    </button>
                  </Link>
                  <Link to="" onClick={(e) => selectCompetition(_, e, true,"status")}>
                    <button className="btn-contained">{textIdentifier['view-status'][lang]}</button>
                  </Link>
                </div>
              </div>
            );
          })}

        {Array.isArray(competitions) && filteredCompetitions.length === 0 && (
          <h6>{textIdentifier['no-competitions-found'][lang]}</h6>
        )}
      </div>
    </div>
  );
}
